import React from 'react'
import Main from './Main'

const Header = () => {
  return <Main />
}

export default Header
